import React from "react";
import { KeyValUnderline } from "../../../../../libraries/ReportGenerator/KeyValUnderline";
export const fadeFormatter = () => {
  return <div style={{ backgroundColor: "black" }}></div>;
};

export const ballastSchema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Ballast Conditions", colSpan: 10, leftAlign: true, accessor: "ballast" }],
  },
];
export const SEIII_TrackCircuitSchema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Calibration and Adjustments", colSpan: 10, leftAlign: false, isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Procedure", colSpan: 4, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Recommended Adjustment", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "Recorded Values or Settings", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,
    columns: [{ title: "Feed End Measurements", colSpan: 10, leftAlign: false, isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "a.", colSpan: 1, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      {
        title: "Track feed transformer (ST-400) Secondary Voltage",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "1 VAC", colSpan: 3, rowSpan: 1, unBold: true, accessor: "requiress", isTitleOnly: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, unBold: true, accessor: "tFeedVolt", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "b.", colSpan: 1, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      {
        title: "Feed end Voltage at Track",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        unBold: true,
        leftAlign: true,
      },
      { title: "1 VAC", colSpan: 3, rowSpan: 1, accessor: "requiress", unBold: true, isTitleOnly: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "fEndVolt", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,
    columns: [{ title: "Relay End Measurements", colSpan: 10, leftAlign: false, isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "c.", colSpan: 1, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      {
        title: "Relay end Voltage at Track",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        unBold: true,
        leftAlign: true,
      },
      { title: "VAC", colSpan: 3, rowSpan: 1, accessor: "requiress", unBold: true, isValueOnly: true, disable: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "relayEndVoltage", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "d.", colSpan: 1, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      {
        title: "Track receive voltage (input voltage to the SE-3 receiver)",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "10.5 - 11.0 VAC", colSpan: 3, rowSpan: 1, accessor: "requiress", unBold: true, isTitleOnly: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "trackReceiveVoltage", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "e.", colSpan: 1, rowSpan: 3, accessor: "loc", isTitleOnly: true },
      {
        title: "Track/Local phase shift measured on SE-3 Receiver",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "-40°; + or - 20° ", colSpan: 3, rowSpan: 1, accessor: "requiress", unBold: true, isTitleOnly: true },
      { title: "Shift", colSpan: 3, rowSpan: 1, accessor: "trackphaseShift", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "Final voltage at ST-200 Primary",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "VAC", colSpan: 3, rowSpan: 1, accessor: "requiress", isValueOnly: true, unBold: true, disable: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "fPrimaryVoltage", leftAlign: true, unBold: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "Final voltage at ST-200 Secondary",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "VAC", colSpan: 3, rowSpan: 1, accessor: "requiress", isValueOnly: true, unBold: true, disable: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "fSecondaryVoltage", leftAlign: true, unBold: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "f.", colSpan: 1, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      {
        title: "Track relay drive (output voltage of the SE-3 receiver)",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "0.415 - 0.450 VDC", colSpan: 3, rowSpan: 1, accessor: "requiress", unBold: true, isTitleOnly: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "trackrelayVoltage", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "g.", colSpan: 1, rowSpan: 3, accessor: "loc", isTitleOnly: true },
      {
        title: "0.06Ω applied to Feed end",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },
      { title: "Expected <.275VDC", colSpan: 3, rowSpan: 3, accessor: "requiress", unBold: true, isTitleOnly: true },
      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "aFeedEnd1Voltage", unBold: true, leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "0.06Ω applied to Mid Point",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },

      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "aMidPointVoltage", leftAlign: true, unBold: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "0.06Ω applied to Relay end ",
        colSpan: 3,
        rowSpan: 1,
        accessor: "requiress",
        isTitleOnly: true,
        leftAlign: true,
        unBold: true,
      },

      { title: "Voltage", colSpan: 3, rowSpan: 1, accessor: "aRelayEndVoltage", leftAlign: true, unBold: true },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/SEIII/SEIII_TrackCircuitSchema.jsx